import React from 'react';
import {ScenarioActionProps} from '../../actionMenuTypes';
import {useLocation} from 'react-router-dom';
import {getUrlRoute, MRAppRoutes} from '../../../router/routes';
import SideBarLinkItem from '../../../layout/common/SideBarLinkItem';
import {tid} from '../../../../testUtils';
import {SUBMODEL_ACTION_MENU_IDS} from '../../../../test/types';
import {DataView16} from '@carbon/icons-react';

const ScenarioDetailActionMenuLink: React.FC<Partial<ScenarioActionProps>> = ({model, scenario}) => {
  const location = useLocation();
  const link =
    model && scenario
      ? getUrlRoute(MRAppRoutes.SCENARIO_DETAIL, {
          modelUuid: model.uuid,
          scenarioId: scenario.id,
        })
      : '#';

  return (
    <SideBarLinkItem
      {...tid(SUBMODEL_ACTION_MENU_IDS.SCENARIO_DETAIL)}
      selected={location.pathname === link}
      disabled={!model || !scenario}
      linkTo={link}
      icon={<DataView16 />}
      text="Detail"
    />
  );
};

export default ScenarioDetailActionMenuLink;
